import { MouseEventHandler } from "react";
import TransactionButtonInternal from "./transaction-button-internal";

type Props = {
	title: string,
	onClick: MouseEventHandler
}

export default function TransactionButton({ title, onClick }: Props) {
   
	return (
    <button type="submit" onClick={onClick} className="btn-primary flex items-center justify-center border">
      <TransactionButtonInternal title={title} />
    </button>
  );
}